export const translation = {
  title: "Lofliedere",
  path_hymn: "lied",
  path_present: "vertoon",
  share_app: "Deel Advent Lofliedere",
  fullscreen_exit: "Verlaat Volskerm",
  fullscreen: "Volskerm",
  settings: "Instellings",
  search_hymns: "Soek deur Liedere",
  no_favorites: "Geen gunstellinge nie.",
  no_hymns_to_learn: "Geen liedere om te leer nie.",
  no_history: "Geen geskiedenis nie.",
  hymn_count: 481,
  website_base_url: "https://www.adventlofliedere.co.za",
  url_play_store: "https://play.google.com/store/apps/details?id=za.co.adventlofliedere",
  url_app_store: "https://apps.apple.com/za/app/advent-lofliedere/id1564068902",
  correction_message: "Dankie vir u bereidwilligheid om uit te help met Advent Lofliedere." +
    "\n\nBeskryf asseblief u voorstel in hierdie e=pos en/of maak enige wysigings aan die bestaande lied hieronder" +
    " en lig die veranderinge uit. " +
    "As die wysiging(s) klaar is, stuur asseblief hierdie e-pos aan die adres wat reeds ingevul is. " +
    "Ons sal die voorstel dan oorweeg en dit in 'n toekomstige weergawe wysig indien nodig.",
  correction_subject: "Voorstel vir Wysiging - Lied",
  correction_email: "kaalvoetjaco@gmail.com",
  share_message: '🎵🎹 Advent Lofliedere op jou selfoon! 🎻🎶' +
    '\n' +
    '\nLaai gratis af: ' +
    '\n' +
    '\nPlay Store: https://play.google.com/store/apps/details?id=za.co.adventlofliedere' +
    '\n' +
    '\nApp Store: https://apps.apple.com/za/app/advent-lofliedere/id1564068902' +
    '\n' +
    '\nOf gebruik dit aanlyn: https://www.adventlofliedere.co.za',
  hymn: "Lied",
  verse: "Vers",
  refrain: "Refrein",
  hymn_number_too_large: "`Lied nommer kan nie meer as 481 wees nie`",
  text_size: 'Teks Grootte',
  instruments: "Instrumente",
  instrument: {
    piano: "Klavier",
    organ: "Orrel",
    violin: "Viool",
    harp: "Harp",
    flute: "Fluit",
    guitar: "Gitaar",
    ensemble: "Ensemble",
    electric_piano: "Elektriese Klavier",
    synth: "Synth",
    voice: "Koor",
    random: "Willekeurig",
    none: "Geen",
    music_box: "Musiekboks",
    lead: "Melodie",
    accompaniment: "Begeleiding",
  },
  autoscroll_disabled: 'Lied Autoblaai Afgeskakel',
  autoscroll_enabled: 'Lied Autoblaai Geaktiveer',
  play_all_favorites: 'Speel alle Gunstellinge',
  play_all_favorites_description: "Willekeurige orde met woorde wat automaties oor die skerm beweeg",
  random_favorite: "Willekeurige Gunstelling",
  random_favorite_description: "Maak enige gunstelling loflied oop",
  random_hymn_description: "Maak enige loflied oopn",
  continued: "vervolg",
  add_to_favorites: "Voeg by Gunstellinge",
  add_to_hymns_to_learn: "Voeg by Wil Graag Leer",
  random_hymn: "Willekeurige Lied",
  listen: "Luister",
  stop: "Stop",
  remove_from_favourites: "Verwyder van Gunstellinge",
  remove_from_hymns_to_learn: "Verwyder van Wil Graag Leer",
  go_to_hymn_number: "Gaan na Lied Nommer",
  change_font_size: "Teks Instellings",
  label_font_size: "Teks Grootte",
  label_lines_per_verse: "Reëls per Vers",
  label_font_weight: "Skrifdikte",
  label_alignment: "Belyning",
  label_text_outline: "Teks Buitelyne",
  share_hymn: "Deel Lied",
  shortcuts: "Kortpadsleutels",
  suggest_correction: "Stel Wysiging Voor",
  lines_per_verse: 'Aantal reëls per vers',
  stop_automatic_playback: "Stop Automatiese Terugspeel",
  title_full: "Advent Lofliedere",
  presentation_mode: "Vertoonmodus",
  read_mode: "Leesmodus",
  shortcut: {
    display_shortcuts: "Vertoon Kortpadsleutels",
    hymn_list: "Vertoon Loflied Lys",
    keypad: "Vertoon Nommerbord",
    random_hymn: "Willekeurige Lied",
    random_favorite: "Willekeurige Gunstelling",
    play_pause: "Speel / Stop Musieksnit",
    autoscroll: "Aktiveer Lied Outoskrol",
    change_mode: "Vertoonmodus / Leesmodus",
    next_verse: "Volgende Vers",
    next_hymn: "Volgende Lied",
    previous_verse: "Vorige Vers",
    previous_hymn: "Vorige Lied",
    go_to_refrain: "Gaan na Refrein",
    go_to_number: "Gaan na Vers Nommer",
    increase_fontsize: "Maak Teks Groter",
    decrease_fontsize: "Maak Teks Kleiner",
    increase_playback_speed: "Vinniger Tempo",
    decrease_playback_speed: "Stadiger Tempo",
    reset_playback_speed: "Herstel Tempo",
  },
  what_is_new_title: "Wat is nuut in Adventlofliedere",
  press_back_to_exit: "Druk weer 'terug' knoppie om uit te gaan",
  info_messages: null,
  app_base_key: "za.co.adventlofliedere",
  app_settings_key: "za.co.adventlofliedere.settings",
  themes: "Kleurskema",
  theme: {
    light: "Lig",
    bird: "Sweef",
    blossoms: "Bloeisels",
    clouds: "Geel Roos",
    desert: "Woestyn",
    field: "Blommeveld",
    geese: "Ganse",
    hills: "Heuwels",
    lake: "Skemer",
    ocean: "Strand",
    path: "Pad",
    seascape: "Skemer Kus",
    stars: "Sterre",
    thunderstorm: "Donderstorm",
    wheat: "Koring",
    dark: "Donker",
    black: "Swart",
  },
  enable_background: "Vertoon Agtergrond",
  blur_background: "Blur Agtergrond",
  music: "Musiek",
  play_intro: "Speel Inleiding",
  text: "Teks",
  text_outline: "Buitelyne",
  screen_timeout: "Hou Skerm Aan",
  screen_timeout_description: "Die skerm sal aangehou word, al is daar geen interaksie met die app nie",
  screen_allowsleep_description: "Die skerm sal afgaan na 'n sekere tydperk wat dit nie gebruik word nie",
  saved_hymns: "Gestoorde Liedere",
  clear_favorites: "Verwyder Gunstellinge",
  clear_favorites_confirm: "Is jy seker jy wil al jou gunstelling liedere verwyder?",
  clear_hymns_to_learn: "Verwyder Wil Graag Leer",
  clear_history: "Verwyder Geskiedenis",
  clear_hymns_to_learn_confirm: "Is jy seker jy wil al jou \"Wil graag leer\" liedere verwyder?",
  clear_history_confirm: "Is jy seker jy wil jou geskiedenis verwyder?",
  play_all_hymns: 'Speel alle Lofliedere',
  play_all_hymns_description: 'Willekeurige orde met woorde wat automaties oor die skerm beweeg',
  extra: 'Ekstra',
  all_hymns: 'Alle Liedere',
  favorites: 'Gunstelinge',
  hymns_to_learn: 'Wil Graag Leer',
  history: 'Geskiedenis',
  faster_tempo: "Vinniger Tempo",
  slower_tempo: "Stadiger Tempo",
  reset_tempo: "Herstel Tempo",
  transpose: "Toonaard",
  increase_key_one: "Verhoog toonaard",
  decrease_key_one: "Verlaag toonaard",
  reset_transpose: "Herstel toonaard",

  path_guess_the_hymn: "raai-die-loflied",
  card_title_guess_the_hymn: "Raai die Loflied",
  card_description_guess_the_hymn: "Kan jy raai watter lied by die wysie pas?",
  url: "https://www.adventlofliedere.co.za",

  use_online: "Gebruik Aanlyn",
  use_online_description: "Besoek adventlofliedere.co.za op jou rekenaar, projektor of slim TV",
  guess_the_hymn: {
    title: "Raai die Loflied",
    scoreboard_title: "🏆 Tellingbord",
    add_more_favorites: "Voeg nog {x} lofliedere by Gunstellinge of \"Wil graag leer\" om hierdie opsie te kies",
    single_player: "Een Speler",
    two_player: "Twee Spelers",
    two_player_instruction: "Kies die korrekte opsie voor die ander speler. Die eerste speler met {x} punte is die wenner!",
    which_hymn: "Watter loflied speel nou?",
    you_win: "Jy het gewen! 🥇",
    you_lose: "Tweede plek! 🥈",
    draw: "Gelykop! 🤝",
    correct: "Jy het reg gekies! ⭐",
    too_slow: "Jy was te stadig! 🐢",
    incorrect: "Jy het verkeerd gekies! ❌",
    single_player_instruction: "Kies soveel korrekte lofliedere as moontlik voor jou hartjies opraak!",
    well_done: "Wel gedaan!",
    game_over: "Spel verby 💔",
    new_high_score: "Nuwe beste telling! 🎉",
    fast: `Dit was vinnig! 🔥`,
    correct_single: `Jy het reg gekies! ✓️`,
    incorrect_single: `Jy het verkeerd gekies! 💔`,
    volume_up: "Maak seker jou klank is aan",
    exit: "Gaan Uit",
    wait_for_player: "Wag vir speler",
    begin: "Begin",
    score: "Telling",
  },
  new: "NUUT",
  debug: false,
  enableDisableInstruments: "Aktiveer of deaktiveer instrumente. Gedeaktiveerde instrumente sal nie in die musieklys verskyn nie en sal nie gebruik word wanneer 'n willekeurige instrument gekies word nie."
};
